module.exports = __webpack_public_path__ + "static/img/logo.59e017e5.png";